/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';

const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const trackingUtils = require('od-modules/utils/tracking.utils');
const TRACKING_ACTION = 'unlocked';
const formatDiscount = (discount) => {
    return discount.replace('-', '');
};

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    events: {
        'tap .membership_perks_link': 'onMembershipPerksLink',
        'tap .cancel_subscription_nag': 'onOpenNag',
        'tap .keep_membership': 'onKeepMembership',
        'tap .cancel_membership': 'onCancelMembership',
    },
    selectors: {
        renewalContainer: '.membership_renewal_container',
        renewalContent: '.membership_renewal_content',
        cancelSubscriptionNag: '.cancel_subscription_nag',
        cancelSubscriptionContainer: '.cancel_subscription_container',
        keepPrime: '.keep_membership',
        cancelPrime: '.cancel_membership',
    },
    initialize(options) {
        BaseView.prototype.initialize.call(this, options);
        this.loadTimes = 0;
        this.updateCachedViewListener();
        this.options.membershipDiscountFmtd = formatDiscount(this.options.membershipDiscountFmtd);
        this.updateKeys();
    },
    updateKeys() {
        const membershipRenewalHeaderTitle = this.buildRenewalHeaderTitle();
        this.keys.membershipRenewalHeaderTitle = Odigeo.Utils.replaceCmsKeyArgs(
            membershipRenewalHeaderTitle, this.options.membershipSubscriptionPriceFmtd);
        this.keys.membershipRenewalCancelSubscriptionTitle = Odigeo.Utils.replaceCmsKeyArgs(
            this.keys.membershipRenewalCancelSubscriptionTitle, this.options.membershipDiscountFmtd);
        this.keys.membershipRenewalCancelSubscriptionSubtitle = Odigeo.Utils.replaceCmsKeyArgs(
            this.keys.membershipRenewalCancelSubscriptionSubtitle, this.options.membershipSubscriptionPriceFmtd);
    },
    buildRenewalHeaderTitle() {
        return this.keys.membershipRenewalHeaderTitle;
    },
    updateCachedViewListener() {
        this.listenTo(this.model, 'change:isRenewalAtFirstBooking', this.render);
        this.listenTo(this.model, 'change:quantity', this.onQuantityChange);
        this.listenTo(this.model, 'change:formattedPrice', this.onSubscriptionOffer);
        this.listenTo(this.model, 'change:renewalGenericError', this.handleGenericRenewalError);
    },
    handleGenericRenewalError() {
        return Odigeo._.noop();
    },
    isRenewalAtFirstBooking() {
        return this.model.get('isRenewalAtFirstBooking');
    },
    render() {
        if (this.isRenewalAtFirstBooking()) {
            this.renderRenewalContainer();
            this.renderCancelSubscriptionContainer();
            this.trackFirstRender();
            this.model.getSubscriptionOffer();
        }
    },
    renderRenewalContainer() {
        this.$cachedSelectors.renewalContainer.html(this.templates.membershipRenewal({
            membershipRenewalHeaderTitle: this.keys.membershipRenewalHeaderTitle,
            membershipRenewalHeaderMore: this.keys.membershipRenewalHeaderMore,
            membershipRenewalContentRenewedTitle: this.keys.membershipRenewalContentRenewedTitle,
            membershipRenewalContentRenewedSubtitle: this.keys.membershipRenewalContentRenewedSubtitle,
            membershipRenewalContentRenewedCancel: this.keys.membershipRenewalContentRenewedCancel,
        }));
    },
    renderCancelSubscriptionContainer() {
        this.$cachedSelectors.cancelSubscriptionContainer.html(this.templates.cancelSubscription({
            membershipRenewalCancelSubscriptionTitle: this.keys.membershipRenewalCancelSubscriptionTitle,
            membershipRenewalCancelSubscriptionSubtitle: this.keys.membershipRenewalCancelSubscriptionSubtitle,
            membershipRenewalCancelSubscriptionBtnPrimary: this.keys.membershipRenewalCancelSubscriptionBtnPrimary,
            membershipRenewalCancelSubscriptionBtnSecondary: this.keys.membershipRenewalCancelSubscriptionBtnSecondary,
        }));
    },
    onMembershipPerksLink() {
        Odigeo.trigger(`${this.id}:openMembershipPerksInfoLightbox`, true);
        Odigeo.trigger(`${this.id}:openOrCloseMembershipDialog`, true);
        trackingUtils.trackEvent(TRACKING_ACTION, 'prime_renew_membership_know_more_clicked');
    },
    onOpenNag() {
        this.toggleCancelSubscriptionNag();
        trackingUtils.trackEvent(TRACKING_ACTION, 'nag_prime_renew');
    },
    onKeepMembership() {
        this.toggleCancelSubscriptionNag();
        trackingUtils.trackEvent(TRACKING_ACTION, 'nag_prime_renew_continue_with_prime');
    },
    onCancelMembership() {
        trackingUtils.trackEvent(TRACKING_ACTION, 'nag_prime_renew_continue_without_prime');
        this.model.updateProduct('remove');
        this.toggleCancelSubscriptionNag();
    },
    onQuantityChange() {
        this.model.onQuantityChange();
        Odigeo.trigger(`${this.id}:membershipSubscriptionChange`, this.model.attributes);
    },
    onSubscriptionOffer() {
        Odigeo.trigger(`${this.id}:membershipSubscriptionStored`, this.model.get('formattedPrice'));
    },
    toggleCancelSubscriptionNag() {
        this.$cachedSelectors.cancelSubscriptionContainer.toggleClass('open opened');
    },
    trackFirstRender() {
        this.loadTimes;
        if (this.loadTimes < 2) {
            trackingUtils.trackEvent(TRACKING_ACTION, 'prime_renew_membership_widget_loaded');
        }
    },
})));
